import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGetTransportadorasResponse } from './transportadora.model';

@Injectable({
  providedIn: 'root'
})
export class TransportadoraService {

  constructor(private http: HttpClient) {}

  public getTransportadoras(): Observable<IGetTransportadorasResponse> {
    const url = `${environment.baseURL}Transportadora/GetTransportadoras`;
    return this.http.get<IGetTransportadorasResponse>(url);
  }

}
